import { SvgIcon, type SvgIconProps } from "@mui/material";

export const FranceTravailIcon = (props: Omit<SvgIconProps, "viewBox">) => (
  <SvgIcon {...props} viewBox="0 0 46 46">
    <path
      style={{ fill: "#283276" }}
      d="M40.9,32.6c0,2.1-1.7,3.9-3.9,3.9c-2.1,0-3.9-1.7-3.9-3.9c0-2.1,1.7-3.9,3.9-3.9C39.2,28.8,40.9,30.5,40.9,32.6  "
    />
    <path
      style={{ fill: "#F29FC5" }}
      d="M15.5,18.2c0,2.1-1.7,3.9-3.9,3.9s-3.9-1.7-3.9-3.9c0-2.1,1.7-3.9,3.9-3.9S15.5,16.1,15.5,18.2"
    />
    <path
      style={{ fill: "#008ECF" }}
      d="M33.7,28.4c0,2.1-1.7,3.9-3.9,3.9S26,30.5,26,28.4c0-2.1,1.7-3.9,3.9-3.9S33.7,26.3,33.7,28.4"
    />
    <path
      style={{ fill: "#F29FC5" }}
      d="M24.3,33.1c0,2.1-1.7,3.9-3.9,3.9s-3.9-1.7-3.9-3.9c0-2.1,1.7-3.9,3.9-3.9S24.3,30.9,24.3,33.1"
    />
    <path
      style={{ fill: "#283276" }}
      d="M24.3,42.1c0,2.1-1.7,3.9-3.9,3.9c-2.1,0-3.9-1.7-3.9-3.9c0-2.1,1.7-3.9,3.9-3.9C22.6,38.3,24.3,40,24.3,42.1"
    />
    <path
      style={{ fill: "#283276" }}
      d="M40.9,13.4c0,2.1-1.7,3.9-3.9,3.9c-2.1,0-3.9-1.7-3.9-3.9c0-2.1,1.7-3.9,3.9-3.9C39.2,9.6,40.9,11.3,40.9,13.4"
    />
    <path
      style={{ fill: "#283276" }}
      d="M33.7,18.2c0,2.1-1.7,3.9-3.9,3.9S26,20.4,26,18.2c0-2.1,1.7-3.9,3.9-3.9S33.7,16.1,33.7,18.2"
    />
    <path
      style={{ fill: "#283276" }}
      d="M15,28.7c0,2.1-1.7,3.9-3.9,3.9s-3.9-1.7-3.9-3.9c0-2.1,1.7-3.9,3.9-3.9S15,26.6,15,28.7"
    />
    <path
      style={{ fill: "#283276" }}
      d="M7.6,12.6c0.5,2.1-0.8,4.1-2.9,4.6c-2.1,0.5-4.1-0.8-4.6-2.9C-0.3,12.2,1,10.1,3,9.7C5.1,9.2,7.2,10.5,7.6,12.6  "
    />
    <path
      style={{ fill: "#E1000F" }}
      d="M7.3,20.9c-0.2,1.2-1.3,2-2.5,1.9c-1.2-0.2-2-1.3-1.9-2.5c0.2-1.2,1.3-2,2.5-1.9C6.6,18.6,7.4,19.7,7.3,20.9"
    />
    <path
      style={{ fill: "#E1000F" }}
      d="M29.4,36.8c-0.2,1.4-1.5,2.3-2.9,2.1c-1.4-0.2-2.3-1.5-2.1-2.9c0.2-1.4,1.5-2.3,2.9-2.1  C28.6,34.1,29.5,35.4,29.4,36.8"
    />
    <path
      style={{ fill: "#E1000F" }}
      d="M36.8,20.8c-0.1,0.8-0.9,1.4-1.7,1.3c-0.8-0.1-1.4-0.9-1.3-1.7c0.1-0.8,0.9-1.4,1.7-1.3  C36.4,19.2,36.9,20,36.8,20.8"
    />
    <path
      style={{ fill: "#E1000F" }}
      d="M21.8,13.7c-0.2,1.2-1.3,2-2.5,1.9c-1.2-0.2-2-1.3-1.9-2.5c0.2-1.2,1.3-2,2.5-1.9C21.2,11.4,22,12.5,21.8,13.7"
    />
    <path
      style={{ fill: "#F29FC5" }}
      d="M28.1,10.8c-0.2,1.2-1.3,2-2.5,1.9c-1.2-0.2-2-1.3-1.9-2.5c0.2-1.2,1.3-2,2.5-1.9C27.5,8.5,28.3,9.6,28.1,10.8"
    />
    <path
      style={{ fill: "#FFE000" }}
      d="M13.9,34.9c-0.2,1.2-1.3,2-2.5,1.9c-1.2-0.2-2-1.3-1.9-2.5c0.2-1.2,1.3-2,2.5-1.9C13.2,32.6,14,33.8,13.9,34.9"
    />
    <path
      style={{ fill: "#FFE000" }}
      d="M35.4,25.1c-0.2,1.2-1.3,2-2.5,1.9c-1.2-0.2-2-1.3-1.9-2.5c0.2-1.2,1.3-2,2.5-1.9  C34.8,22.8,35.6,23.9,35.4,25.1"
    />
    <path
      style={{ fill: "#283276" }}
      d="M32.9,35.3c0.6,1,0.3,2.4-0.7,3c-1,0.6-2.4,0.3-3-0.7c-0.6-1-0.3-2.4,0.7-3C30.9,33.9,32.3,34.3,32.9,35.3"
    />
    <path
      style={{ fill: "#FFE000" }}
      d="M16.2,9.5c-0.2,1.2-1.3,2-2.5,1.9c-1.2-0.2-2-1.3-1.9-2.5c0.2-1.2,1.3-2,2.5-1.9C15.5,7.2,16.3,8.3,16.2,9.5"
    />
    <path
      style={{ fill: "#008ECF" }}
      d="M24.5,4c0,2.2-1.8,4-4,4c-2.2,0-4-1.8-4-4c0-2.2,1.8-4,4-4C22.7,0,24.5,1.8,24.5,4"
    />
    <path
      style={{ fill: "#008ECF" }}
      d="M7.7,32.6c0,2.1-1.7,3.9-3.9,3.9S0,34.7,0,32.6c0-2.1,1.7-3.9,3.9-3.9S7.7,30.5,7.7,32.6"
    />
    <path
      style={{ fill: "#008ECF" }}
      d="M26.7,22.2c0,3.7-3,6.7-6.7,6.7c-3.7,0-6.7-3-6.7-6.7c0-3.7,3-6.7,6.7-6.7C23.7,15.5,26.7,18.5,26.7,22.2"
    />
  </SvgIcon>
);
